var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAQklEQVR42mMYBTQGTyUlz4Aw2ZoX8vGBMYhNluZaDg4QhhtCju3orkgjyQBoGJBiAAIgaUhDZpMalmnI7NF0iR0AAExzL6fl9oLpAAAAAElFTkSuQmCC";
  export default img;